import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "../../../lib/AppContext";
import {
  checkout,
  checkoutTip,
  getCartInvoice,
  getCartInvoiceGroup,
  getCustomerCartFamilyMembers,
  getCustomerCartFull,
  getKioskCartFull,
  guestCheckout,
  removeAttendees,
  saveCustomerFamily,
  setupTerminal,
  updateAttendees
} from "../api/CartApi";

import {Button, Col, Modal} from "react-bootstrap";
import MDButton from "../../../components/MDButton";
import MDBadge from "../../../components/MDBadge";
import IconButton from "@mui/material/IconButton";
import CartItems from "./CartItems";
import CreateAccount from "../../common/CreateAccount";
import Loading from "../../common/Loading";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import {capitalize, formatCurrency} from "../../common/Utils";
import StripeCheckoutPage from "../../StripeCheckoutPage";
import {useNavigate} from "react-router-dom";
import CartFamilyMembers from "./CartFamilyMembers";
import {Grid, InputAdornment} from "@mui/material";
import {CONSTANTS} from "../constants";
import CartSuccess from "./CartSuccess";
import Checkbox from "@mui/material/Checkbox";
import ClientCartInventoryEventMemberships from "../../client/ClientCartInventoryEventMemberships";
import SquareCheckoutPage from "../../SquareCheckoutPage";
import CartForm from "./CartForm";
import MDInput from "../../../components/MDInput";
import CartPerks from "./CartPerks";
import SquareAddPayment from "../SquareAddPayment";
import dayjs from "dayjs";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import LockedAccountForm from "../../form/LockedAccountForm";
import Divider from "@mui/material/Divider";
import {saveAssignCartMembershipMembers} from "../api/WebApi";
import CartDiscounts from "./CartDiscounts";

export default function CartFinal({client, invoice, callback, cartActive}) {

  const [context, setContext] = useContext(AppContext);
  const [cartContext, setCartContext] = useContext(AppContext);

  const [cartReady, setCartReady] = useState(false);
  const [checkoutFinal, setCheckoutFinal] = useState(false);
  const [initialContext, setInitialContext] = useState(true);
  const [guestName, setGuestName] = useState(null);

  useEffect(() => {
    if (initialContext) {
      setInitialContext(false);
      setSquareEnabled(context?.sessionUser?.company?.paymentExtApplicationId === CONSTANTS.EXT_APPLICATION.SQUARE);
    }
  }, [context]);
  const [squareEnabled, setSquareEnabled] = useState(false);

  const [cartItems, setCartItems] = useState([]);
  const [familyMembers, setFamilyMembers] = useState([]);
  const [cart, setCart] = useState();
  const [addPaymentMethod, setAddPaymentMethod] = useState(false);
  const [terminalPayment, setTerminalPayment] = useState(false);

  const [paymentMethod, setPaymentMethod] = useState({});
  const [card, setCard] = useState(null);
  const [cardInvalid, setCardInvalid] = useState(true);
  const [showLogin, setShowLogin] = useState(true);
  const [action, setAction] = useState(null);

  const [membershipReason, setMembershipReason] = useState();
  const [membershipOptions, setMembershipOptions] = useState([]);

  const navigate = useNavigate();

  const [cartCheckIn, setCartCheckIn] = useState(false);

  const [cartMembershipMembers, setCartMembershipMembers] = useState({});

  const [cartMembershipSaving, setCartMembershipSaving] = useState(false);

  const assignAssignCartMembershipMembers = (req) => {
    setCartMembershipSaving(true);
    let _req = {
      request: req
    }
    saveAssignCartMembershipMembers(client, _req).then((resp) => {
      setCartMembershipSaving(false);
      getCartFullFn();
    })
  }
  const validCartMembershipMembers = () => {
    let valid = true;
    for (let j in cartItems) {
      if (cartItems[j].inventoryItem?.lockedAccount) {
        valid = valid && cartMembershipMembers[cartItems[j].cartItemId]?.length > 0
      }
    }
    return valid;
  }
  const updateCartMembershipMembers = (cartItemId, members) => {
    setCartMembershipMembers((prev) => ({
      ...prev,
      [cartItemId]: members,
    }));
  };

  const hasEventToday = () => {
    let isEventToday = false;
    const now = new Date();
    for (let item in cart?.items) {
      if (cart?.items[item]?.inventoryItem?.eventType?.id > -1) {
        let eventDate = new Date(cart?.items[item]?.inventoryItem?.eventDate);
        if (eventDate.getFullYear() === now.getFullYear() &&
          eventDate.getMonth() === now.getMonth() &&
          eventDate.getDate() === now.getDate()
        ) {
          isEventToday = true;
        }
      }
    }
    return isEventToday;
  }

  const hasEvent = () => {
    let isEvent = false;

    for (let item in cart?.items) {
      if (cart?.items[item]?.inventoryItem?.eventType?.id > -1) {
        isEvent = true;
      }
    }

    return isEvent;
  }

  const checkoutDisabled = () => {
    return false;
    // TODO see other 6/20/2025 todo - JP
    let validTerms = true;

    if (cart?.cartTerms == null || cart?.cartTerms.length <= 0) {
      return false;
    }

    for (let j in cart?.cartTerms) {
      let _term = cart?.cartTerms[j];
      validTerms = validTerms && isAgreedTerms(_term);
    }

    if (validTerms) {
      return false;
    }
  }

  useEffect(() => {
    setAddPaymentMethod(false);
    setTerminalPayment(false);
  }, [cartActive]);

  useEffect(() => {
    setAddPaymentMethod(false);
    setTerminalPayment(false);
    if ((cart?.checkoutDisposition === 'VIEW_CHECKOUT' || cart?.checkoutDisposition === 'VIEW_INVOICE') && cart?.billings?.length === 0) {
      setAddPaymentMethod(true);
    }
    if (cart?.checkoutDisposition === 'REQUIRE_ATTENDEES') {
      getCartFamilyMembersFn();
    }
  }, [cart?.checkoutDisposition]);


  const [tipItems, setTipItems] = useState(cart?.tipTypes);

  useEffect(() => {
    if (cart?.tipTypes) {
      setTipItems(cart?.tipTypes);
    }
    setTipItem(null);
    setTipWarn(null);
  }, [cart?.tipTypes]);

  const tipButtonStyle = {
    color: '#111',
    background: '#fff',
    border: 'solid 1px #000',
  };

  const selectedTipButtonStyle = {
    color: '#fff',
    background: '#000',
    border: 'solid 1px #000',
  };


  const [calculatedTipAmount, setCalculatedTipAmount] = useState(0);

  const [tipWarn, setTipWarn] = useState(null);
  const [tipItem, setTipItem] = useState(null);

  const setCustomTip = (amount) => {
    let _tipItem = {...tipItem};
    _tipItem.customTipAmount = amount;
    setTipItem(_tipItem);
  }

  const isTipItemSelected = (id) => {
    return tipItem?.id === id;
  }

  const getCartFamilyMembersFn = async () => {
    getCustomerCartFamilyMembers(client).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        let _members = [];
        for (let j in result) {
          if (result[j].familyMemberType.id === 1) {
            _members.push(result[j]);
          }
        }
        setFamilyMembers(_members);
      }
    });
  }

  const getCartFullFn = async (referrer) => {
    setCartReady(false);
    callback({
      action: 'reload'
    })
    setCartContext({...cartContext, reloadCart: true})

    if (invoice) {
      getCartInvoiceFn(invoice, referrer);
      return;
    }
    if (client?.guid?.length > 0) {
      getCustomerCartFull(client.guid, referrer).then(result => {
        if (result.error) {
          setContext({...context, error: {message: result.message}});
        } else {
          setCart(result);
          setCartReady(true);
        }
      });
    } else {
      getKioskCartFull(referrer).then(result => {
        if (result.error) {
          setContext({...context, error: {message: result.message}});
        } else {
          setCart(result);
          setCartReady(true);
        }
      });
    }
  }

  const getCartInvoiceFn = async (invoice, referrer) => {
    setCartReady(false);
    setCartContext({...cartContext, reloadCart: true});
    if (invoice.invoiceGroup) {
      getCartInvoiceGroup(client?.guid, invoice?.invoiceGroupGuid, referrer || null).then(result => {
        if (result.error) {
          setContext({...context, error: {message: result.message}});
        } else {
          setCart(result);
          setCartReady(true);
        }
      });
    } else {
      getCartInvoice(client?.guid, invoice?.invoiceGuid).then(result => {
        if (result.error) {
          setContext({...context, error: {message: result.message}});
        } else {
          setCart(result);
          setCartReady(true);
        }
      });
    }
  }


  useEffect(() => {
    setCartItems(cartContext?.cartItems);
  }, [cartContext?.cartItems])

  useEffect(()=> {
    let _c = {...cart};
    _c.cartCheckIn = cartCheckIn;
    setCart(_c);
  }, [cartCheckIn]);

  useEffect(() => {
    setCartCheckIn(hasEventToday());
  }, [cart?.items]);

  useEffect(() => {
    if (cartActive) {
      if (invoice) {
        getCartInvoiceFn(invoice);
      } else {
        getCartFullFn();
      }
    }
  }, [cartActive]);

  const handleClose = (action) => {
    const _c = {
      action: action || 'close'
    }
    callback(_c);
  };

  const updateCartAttendees = async () => {
    updateAttendees(cart, client).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        if (result.disposition) {
          let _cart = {...cart};
          _cart.checkoutDisposition = result.disposition;
          _cart.availableAccounts = result.availableAccounts;
          setCart(_cart);
          setMembershipReason(result.message);
        } else {
          setCartContext({...cartContext, reloadCart: true});
          getCartFullFn();
        }
      }
    });
  }

  const [cartError, setCartError] = useState(false);
  const [checkingOut, setCheckingOut] = useState(false);
  const [terminalPending, setTerminalPending] = useState(false);
  const [terminalResponse, setTerminalResponse] = useState();

  const checkoutFn = async () => {
    setCheckingOut(true);
    let _c = {...cart};
    _c.cartCheckIn = cartCheckIn;
    _c.guestName = guestName;

    setCartError(false)
    if (invoiceDueDays != null) {
      _c.invoiceDueDays = parseInt(invoiceDueDays, 10);
    }

    const resp = await (client ? checkout(_c, client) : guestCheckout(_c)).catch(function (error) {
      setCheckingOut(false);
      setCartError(true)
    });
    if (resp) {
      setCheckingOut(false);
      let _cart = {...cart};
      _cart.checkoutDisposition = 'CHECKOUT_SUCCESS';
      _cart.paymentId = resp.paymentId;
      setCart(_cart);
      setAction('success');
      if (cart?.paymentMethod?.chargeTypeId === CONSTANTS.CHARGE_TYPE.TAB) {
        callback({
          action: 'success'
        })
      }
    }
  }

  const [captureCard, setCaptureCard] = useState(false);

  const terminalCheckoutFn = async () => {
    if (captureCard) {
      return;
    }

    let _c = {...cart};
    _c.cartCheckIn = cartCheckIn;
    _c.guestName = guestName;
    setCheckingOut(true);
    setupTerminal(_c, client).then((resp) => {
      setTerminalPending(true);
      setCartReady(false);
      setTerminalResponse(resp);
    });
  }

  const continueToCheckoutFinal = async () => {

    if (tipItem && tipItem?.id) {
      let _cart = {...cart};
      _cart.tipItem = {...tipItem};
      const resp = await checkoutTip(client, _cart);

      if (resp) {
        let _cart = {...cart};
        _cart.purchaseGroupId = resp.purchaseGroupId;
        setCart({..._cart});
      }

    }

    if (cart?.formRequired) {
      let _cart = {...cart};
      _cart.checkoutDisposition = 'EVENT_FORM';
      setCart(_cart);
    } else {
      setCheckoutFinal(true);
    }
  }

  const continueToCheckout = () => {
    getCartFullFn(cart?.checkoutDisposition === 'VIEW_CART' ? 'VIEW_CHECKOUT' : cart?.checkoutDisposition);
  }

  const viewCart = () => {
    setCartContext({...cartContext, viewCart: true});
  }

  const handleLogin = (obj) => {
    continueToCheckout();
  }

  const [displayPaymentMethod, setDisplayPaymentMethod] = useState('new');

  const [cartBillingsRefreshIndex, setCartBillingsRefreshIndex] = useState(1);

  useEffect(() => {
    cart?.billings?.sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1).map((b, idx) => {
      if (b.primaryCard) {
        setDisplayPaymentMethod(b?.guid);
      }
    })
  }, [cart?.billings?.length, cartBillingsRefreshIndex]);

  const updatePaymentMethod = (item, isAddPaymentMethod) => {
    setCartError(false);
    setAddPaymentMethod(isAddPaymentMethod || false);
    let _cart = {...cart};
    _cart.paymentMethod = item;
    setCart(_cart);
  };

  const toggleCashPaymentMethod = () => {
    setCard(null);
    setAddPaymentMethod(false);
    setTerminalPayment(false);
    let _item = {
      cash: true,
      chargeTypeId: CONSTANTS.CHARGE_TYPE.CASH
    }
    updatePaymentMethod(_item);
  };

  const toggleTabPaymentMethod = () => {
    setCard(null);
    setAddPaymentMethod(false);
    setTerminalPayment(false);
    let _item = {
      cash: false,
      tab: true,
      chargeTypeId: CONSTANTS.CHARGE_TYPE.TAB
    }
    updatePaymentMethod(_item);
  };


  const toggleStoreCardaymentMethod = () => {
    setCard(null);
    let recurringCapture = hasRecurringItems();
    setAddPaymentMethod(false);
    setTerminalPayment(true);
    let _item = {
      cash: false,
      terminal: true,
      chargeTypeId: CONSTANTS.CHARGE_TYPE.TERMINAL,
      recurringCapture: recurringCapture
    }

    updatePaymentMethod(_item);

  };

  const [invoiceDueDays, setInvoiceDueDays] = useState(0);
  const [invoiceDueDate, setInvoiceDueDate] = useState(dayjs(new Date()));
  const [cashReceived, setCashReceived] = useState(0);
  const [changeAmount, setChangeAmount] = useState(0);

  useEffect(() => {
    setChangeAmount(0);
    if (cart && cart?.amountDue && cashReceived) {
      setChangeAmount(parseFloat(parseFloat(cashReceived) - parseFloat(cart?.amountDue)).toFixed(2));
    }
  }, [cashReceived, cart])

  const toggleInvoicePaymentMethod = () => {
    setCard(null);
    setAddPaymentMethod(false);
    setTerminalPayment(false);
    let _item = {
      invoice: true,
      chargeTypeId: CONSTANTS.CHARGE_TYPE.INVOICE
    }
    updatePaymentMethod(_item);
  };

  const addPaymentMethodFn = () => {
    setCard(null);
    setAddPaymentMethod(true);
    let _item = {
      cash: false,
      terminal: false,
      chargeTypeId: CONSTANTS.CHARGE_TYPE.CARD,
    }
    updatePaymentMethod(_item, true);
  };

  const handleCardChange = (card) => {
    if (!card) {
      return;
    }
    if (!cart) {
      return;
    }
    setCard(card);
    setCardInvalid(!card?.card?.isValid);

    let _paymentMethod = {...card};
    let _cart = {...cart};
    _cart.paymentMethod = _paymentMethod;
    setCart(_cart);
  };

  const [cartRenderIdx, setCartRenderIdx] = useState(1);
  const [familyMemberRenderIdx, setFamilyMemberRenderIdx] = useState(1);

  const [addDiscounts, setAddDiscounts] = useState(false);
  const [giftItemOpen, setGiftItemOpen] = useState(false);

  const cartCallback = (data) => {
    setCartRenderIdx(cartRenderIdx + 1);

    if (data?.action === 'close') {
      handleClose('close');
      return;
    }
    if (data?.action === 'discount') {
      setAddDiscounts(true);
      return;
    }

    if (data?.action === 'setItemDiscount') {
      setAddDiscounts(false);
      return;
    }

    setCart(data);
    callback({
      action: 'reload',
    });
  }

  const familyMemberFn = async (data) => {
    setCartReady(false);
    removeAttendees(client, data).then((resp) => {
      getCartFullFn();
    });
  }

  const [familyMemberForm, setFamilyMemberForm] = useState();

  const saveChildMember = () => {
    saveCustomerFamily(familyMemberForm).then(r => {
      getCartFullFn();
    });
  }

  const familyMemberCallback = (form) => {
    let _form = {...form};
    _form.parentGuid = client.guid;
    setFamilyMemberForm(_form);
    setFamilyMemberRenderIdx(familyMemberRenderIdx + 1);
  }
  const [waiverVisible, setWaiverVisible] = useState(false);
  const [waiver, setWaiver] = useState();

  const showWaiver = (_waiver) => {
    setWaiverVisible(true);
    setWaiver(_waiver);
  }

  const [termsAgreed, setTermsAgreed] = useState([]);
  const agreedTerms = (item) => {
    let _termsAgreed = [...termsAgreed];
    let _item = _termsAgreed.indexOf(item.waiverGuid);
    if (_item > -1) {
      _termsAgreed.splice(_item, 1);
    } else {
      _termsAgreed.push(item.waiverGuid);
    }
    setTermsAgreed(_termsAgreed);
  }
  const isAgreedTerms = (item) => {
    return termsAgreed.indexOf(item.waiverGuid) > -1;
  }
  const hasCartTerms = () => {
    return false; // TODO 6-20/2025 - assign waiver to the customer
    // return cart?.cartTerms && cart?.cartTerms?.length > 0;
  }

  const hasRecurringItems = () => {
    let hasRecurring = false;
    for (const item in cart?.items) {
      if (cart?.items[item]?.inventoryItem?.accountType?.recurring) {
        hasRecurring = true;
      }
    }

    return hasRecurring;
  }

  const dispositionCheckout = (disposition) => {
    let isCheckoutDisposition = false;
    if (disposition === 'VIEW_CHECKOUT') {
      isCheckoutDisposition = true;
    }
    if (disposition === 'CHECKOUT_VALID') {
      isCheckoutDisposition = true;
    }
    if (disposition === 'QUICK_CHECKOUT') {
      isCheckoutDisposition = true;
    }
    if (disposition === 'GIFT_CARD_PURCHASE') {
      isCheckoutDisposition = true;
    }

    return isCheckoutDisposition;
  }

  const dispositionHelp = (disposition) => {
    let helpText = '';
    if (disposition === 'MANAGE_FAMILY_MEMBERS') {
      helpText = ' - Add Child';
    }
    if (disposition === 'REQUIRE_ATTENDEES') {
      helpText = ' - Attendees Required';
    }
    if (disposition === 'VIEW_CHECKOUT') {
      helpText = ' - Checkout';
    }
    if (disposition === 'CHALLENGE_ACCOUNT') {
      helpText = ' - Please Sign In';
    }
    if (disposition === 'CHECKOUT_VALID') {
      helpText = ' - Complete Purchase';
    }
    if (disposition === 'QUICK_CHECKOUT') {
      helpText = ' - Complete Purchase';
    }
    if (disposition === 'GIFT_CARD_PURCHASE') {
      helpText = ' - Complete Purchase';
    }
    if (disposition === 'CART_API_ERROR') {
      helpText = ' - Payment Error';
    }
    if (disposition === 'MEMBERSHIP_REQUIRED') {
      helpText = ' - Additional Membership Required';
    }
    if (disposition === 'EVENT_FORM') {
      helpText = ' - Please Complete Event Form';
    }
    if (disposition === 'LOCKED_MEMBERSHIP_ASSIGN_FAMILY') {
      helpText = ' - Assign Member';
    }

    return helpText;
  }


  const handleSquareCartSuccess = (e) => {

    let _cart = {...cart};
    _cart.checkoutDisposition = 'CHECKOUT_SUCCESS';
    _cart.paymentId = e.paymentId;
    setCart(_cart);

    setAction('success')
  }

  const handleCartSuccess = (e) => {

    let _cart = {...cart};
    _cart.checkoutDisposition = 'CHECKOUT_SUCCESS';
    _cart.paymentId = e.paymentIntent.id
    setCart(_cart);

    setAction('success')
  }


  const handleSuccessDisposition = (disposition) => {
    let _cart = {...cart};
    _cart.checkoutDisposition = disposition;
    setCart(_cart);
  }

  const recalculateCart = () => {
    let _ref = cart?.applyGiftCard ? 'REMOVE_GIFT_CARD' : 'APPLY_GIFT_CARD';
    getCartFullFn(_ref);
  }

  const recalculateCartInvoice = () => {
    let _ref = cart?.applyGiftCard ? 'REMOVE_GIFT_CARD' : 'APPLY_GIFT_CARD';
    getCartInvoiceFn(invoice, _ref);
  }

  const cartSuccessCallback = (action) => {
    if (action === 'success') {
      let _c = {...cart};
      _c.checkoutDisposition = 'CHECKOUT_SUCCESS_FINAL';
      setCart(_c);
    }
  }

  const applyDiscountItem = () => {
    setAddDiscounts(false);
  }

  const sanitizeCardType = (item) => {
    let t = capitalize(item.cardType);
    if (t === 'AMERICAN_EXPRESS') {
      return 'AMEX';
    }
    return t;
  }

  return (
    <>
      <IconButton
        size="small"
        disableRipple
        color="primary"
        aria-controls="notification-menu"
        aria-haspopup="true"
        variant="contained"
        onClick={() => {
          viewCart()
        }}
      >
        {cartItems?.length > 0 && <MDBadge badgeContent={cartItems?.length} color="error" size="xs" circular>
          <span className="fa fa-cart-shopping"/>
        </MDBadge>}
      </IconButton>

      <Modal size={'xl'} className={hasEvent() ? 'modal-body-check-in-context' : ''} onHide={() => {
        handleClose(action)
      }}
             show={cartActive}>
        <Modal.Header closeButton>
          <Modal.Title style={{
            marginBottom: hasEvent() && dispositionCheckout(cart?.checkoutDisposition) ? '0' : 'auto'
          }}>
            {client?.guid ? <span style={{
              fontWeight: 'bolder',
              textDecoration: 'underline'
            }}>{client.firstName + ' ' + client.lastName}</span> : 'Guest'}
            {cart?.invoice ? ' Invoice' : ' Cart'} {dispositionHelp(cart?.checkoutDisposition)}

            {!terminalPending && hasEvent() && dispositionCheckout(cart?.checkoutDisposition) && <span style={{
              fontSize: '14px',
              margin: '-20px 0',
            }}>
                    <p style={{
                      margin: '0',
                      padding: '0',
                      lineHeight: '12px'
                    }}>
                      <br/>
                      <label><Checkbox
                        checked={cartCheckIn}
                        onChange={(e) => {
                          setCartCheckIn(!cartCheckIn)
                        }}
                      /><b>Check-In Automatically</b>
                    </label>
                    </p>
                  </span>}
          </Modal.Title>
        </Modal.Header>
        {!cartReady && !terminalPending &&
          <Loading/>
        }
        {terminalPending &&
          <>
            {terminalResponse &&
              <>
                <Modal.Body className={'modal-overflow'}>
                  <CartSuccess clientGuid={client?.guid}
                               paymentId={terminalResponse?.paymentId}
                               callback={() => {
                               }}
                               paymentMethod={{
                                 square: true
                               }}/>
                </Modal.Body>
              </>
            }
          </>
        }

        {captureCard && <>
          <SquareAddPayment
            client={client}
            show={captureCard}
            handleClose={(e) => {
              setCaptureCard(false);
              setDisplayPaymentMethod(null);
              updatePaymentMethod(null);
              getCartFullFn();
              setCartBillingsRefreshIndex(cartBillingsRefreshIndex + 1);
            }}/>
        </>}

        {cartReady && <>
          <Modal.Body className={'modal-overflow'}>
            {cart?.checkoutDisposition === 'CART_API_ERROR' && <>
              <MDTypography variant="p" className={'mt-3'} fontWeight="regular">
                {cart?.error && cart?.error || 'An error occurred.'}
              </MDTypography>

              <Grid item xs={12}>
                <MDTypography variant="p"
                              fontWeight="normal">
                  <center>
                    <br/><br/>
                    <MDButton variant="gradient"
                              color="info"
                              onClick={() => {
                                setCheckingOut(false);
                                setCartContext({...cartContext, reloadCart: true});
                                getCartFullFn();
                              }}>Refresh</MDButton>
                  </center>
                </MDTypography>
              </Grid>

            </>}

            {cart?.checkoutDisposition === 'EVENT_FORM' && <>
              {cart?.items?.filter(x => x?.inventoryItem?.formActive).map((item, idx) => {
                return (
                  <div key={idx}>
                    <CartForm client={client}
                              callback={() => {
                                getCartFullFn()
                              }}
                              form={item.inventoryItem.form}/>

                  </div>
                )
              })
              }
            </>}

            {(cart?.checkoutDisposition === 'CHECKOUT_SUCCESS'
                || cart?.checkoutDisposition === 'CHECKOUT_SUCCESS_FINAL') && cart?.paymentId &&
              <CartSuccess
                clientGuid={client?.guid}
                paymentId={cart.paymentId}
                callback={cartSuccessCallback}
                paymentMethod={cart.paymentMethod}
              />}

            {cart?.checkoutDisposition === 'ADD_FAMILY_MEMBERS' && <center style={{
              width: '80%',
              margin: '0 auto'
            }}>

              <h5>An event you are registering for requires
                attendees</h5>
              <MDTypography variant="p" className={'mt-3'} fontWeight="regular">
                Please continue to add family members.
              </MDTypography>

              <div>
                <MDButton
                  className={'mt-3'}
                  color="primary"
                  onClick={() => {
                    let _cart = {...cart};
                    _cart.checkoutDisposition = 'MANAGE_FAMILY_MEMBERS'
                    setCart(_cart);
                  }}>Continue</MDButton>
              </div>

            </center>}

            {cart?.checkoutDisposition === 'MANAGE_FAMILY_MEMBERS' && <>
              <CartFamilyMembers familyMembers={familyMembers}
                                 callback={familyMemberCallback}/>
            </>}
            {cart?.checkoutDisposition === 'MEMBERSHIP_REQUIRED' && <>

              <Grid item xs={12}>
                <h5>
                  An event you are registering for requires a membership
                </h5>
              </Grid>
              <Grid item xs={12}>
                <MDTypography variant="p" style={{
                  display: 'block',
                  clear: 'both'
                }} className={'mt-3'} fontWeight="regular">
                  Please add membership below.
                </MDTypography>
              </Grid>

              <Grid item xs={12}>
                <ClientCartInventoryEventMemberships
                  cartItem={cart?.flaggedItem}
                  memberships={cart?.availableAccounts}
                  handleSave={(data) => {
                    getCartFullFn();
                  }}
                />
              </Grid>


            </>}
            <Grid container px={2}>
              {cart?.checkoutDisposition === 'CART_ERROR' && <>
                <Grid item xs={12}>
                  <MDTypography variant="p"
                                fontWeight="normal">
                    <center>
                      {cart?.error && cart?.error}
                      <br/>
                      Please refresh your cart.
                      <br/><br/>
                      <MDButton variant="gradient"
                                color="info"
                                onClick={() => {
                                  setCheckingOut(false);
                                  setCartContext({...cartContext, reloadCart: true});
                                  getCartFullFn();
                                }}>Refresh</MDButton>
                    </center>
                  </MDTypography>
                </Grid>
              </>}

              {cart?.checkoutDisposition === 'LOCKED_MEMBERSHIP_ASSIGN_FAMILY' && <>
                {cart?.items?.filter((item) => item?.inventoryItem?.lockedAccount).map((item, idx) => {
                  return (
                    <Grid item xs={12} key={idx}>
                      <LockedAccountForm inventory={item?.inventoryItem}
                                         client={client}
                                         siblingQuantity={item?.quantity}
                                         callback={(cb) => {
                                           updateCartMembershipMembers(item?.cartItemId, cb?.membershipMembers);
                                         }}
                      />

                      <Divider/>
                    </Grid>
                  )
                })
                }
              </>}

              {(cart?.checkoutDisposition === 'VIEW_CART'
                || cart?.checkoutDisposition === 'VIEW_INVOICE'
                || cart?.checkoutDisposition === 'REQUIRE_ATTENDEES'
                || cart?.checkoutDisposition === 'VIEW_CHECKOUT'
                || cart?.checkoutDisposition === 'CHECKOUT_VALID'
                || cart?.checkoutDisposition === 'GIFT_CARD_PURCHASE'
                || cart?.checkoutDisposition === 'QUICK_CHECKOUT') && <>

                <CartItems
                  cart={cart}
                  client={client}
                  getCartFullFn={getCartFullFn}
                  callback={cartCallback}
                  tipItem={tipItem}
                  paymentMethod={displayPaymentMethod}
                  familyMemberCallback={familyMemberFn}
                  giftItemCallback={(open) => {
                    setGiftItemOpen(open)
                  }}
                >

                  {!checkoutFinal && <>

                    <CartPerks client={client} cart={cart} getCartFullFn={getCartFullFn}/>

                    {!cart?.invoice && <>
                      <CartDiscounts client={client} cart={cart} getCartFullFn={getCartFullFn}/>
                    </>}

                    {(cart?.amountDue > 0 || (cart?.amountDue === 0 && 'GIFT_CARD_PURCHASE' === cart.checkoutDisposition)) && cart?.giftCardBalance > 0 &&
                      <div className={'psb-bordered my-2'} style={{
                        background: '#f6f1f1'
                      }}>
                        <h6>
                          You have a gift card balance of {formatCurrency(cart?.giftCardBalance)}
                        </h6>
                        <label htmlFor={'applyGiftCard'}><Checkbox
                          checked={cart?.applyGiftCard}
                          name={'applyGiftCard'}
                          id={'applyGiftCard'}
                          onChange={() => {
                            cart?.invoice ? recalculateCartInvoice() : recalculateCart();
                          }}
                        />&nbsp;Yes, apply gift card to purchase
                        </label>
                      </div>
                    }
                  </>
                  }

                  {!checkoutFinal && hasCartTerms() && <>
                    <div style={{
                      display: 'block',
                      width: '100%',
                    }}>
                      <MDTypography variant="p"
                                    fontWeight="light">
                        One or more events in your customer's cart requires a waiver prior to purchase.
                      </MDTypography>
                    </div>
                    {cart?.cartTerms?.map((term, index) => {
                      return (<div key={index} style={{
                        display: 'block',
                        width: '100%',
                      }}>
                        <label htmlFor={'terms-' + term.waiverGuid}><Checkbox
                          checked={isAgreedTerms(term)}
                          name={'terms-' + term.waiverGuid}
                          onChange={() => {
                            agreedTerms(term)
                          }}
                        />&nbsp;Assign Waiver to Customer <a href="#" onClick={(e) => {
                          e.preventDefault();
                          showWaiver(term)
                        }}>{term.waiverName}</a>
                        </label>
                      </div>)
                    })}
                  </>}

                  {(cart?.checkoutDisposition === 'VIEW_CHECKOUT' ||
                    cart?.checkoutDisposition === 'VIEW_INVOICE' ||
                    cart?.checkoutDisposition === 'CHECKOUT_VALID') && <>
                    {!checkoutFinal &&
                      <>

                        {cart?.invoiceCheckout && cart.tippingEnabled && tipItems?.length > 0 && <Grid container>
                          <Grid item xs={12}>
                            <div variant="outlined" aria-label="Basic button group">
                              {tipItems?.sort((a, b) => a.sortOrder - b.sortOrder).map((item, idx) => {
                                return (
                                  <Button key={idx}
                                          variant="outlined"
                                          onClick={(e) => {
                                            setTipItem(item);
                                            setCalculatedTipAmount(cart.itemsTotal * (item.tipPercentage * .01))
                                          }}
                                          style={isTipItemSelected(item.id) ? selectedTipButtonStyle : tipButtonStyle}>
                                    <small style={{
                                      fontWeight: 'bold',
                                      display: 'block',
                                      width: '100%',
                                      textAlign: 'center'
                                    }}>{item.tipPercentage}% <br/> {formatCurrency(item.tipAmount)}</small>
                                  </Button>
                                )
                              })
                              }
                              <Button
                                variant="outlined"
                                onClick={(e) => {
                                  setTipItem({
                                    id: -1,
                                    customEnabled: true
                                  });
                                  setCalculatedTipAmount(0)
                                }}
                                style={isTipItemSelected(-1) ? selectedTipButtonStyle : tipButtonStyle}
                              >
                                <small style={{
                                  fontWeight: 'bold',
                                  display: 'block',
                                  width: '100%',
                                  textAlign: 'center',
                                  padding: '8px 0 9px 0'
                                }}>Other</small>
                              </Button>
                              <Button variant="outlined"
                                      onClick={(e) => {
                                        setTipItem({
                                          id: -10,
                                          customEnabled: false
                                        });
                                        setCalculatedTipAmount(0)
                                      }}
                                      style={isTipItemSelected(-10) ? selectedTipButtonStyle : tipButtonStyle}
                              ><small style={{
                                fontWeight: 'bold',
                                display: 'block',
                                width: '100%',
                                textAlign: 'center',
                                padding: '8px 0 9px 0'
                              }}>None
                              </small></Button>
                              {tipItem?.customEnabled && <>
                              <span style={{
                                display: 'block', margin: '4px',
                              }}>
                                <small>Enter tip amount: </small><br/>
                                <MDInput type={'text'}
                                         required={tipItem?.customEnabled}
                                         disabled={!tipItem || !tipItem?.customEnabled}
                                         placeholder={'0.00'}
                                         onChange={(e) => {
                                           let _amount = e.target.value;
                                           _amount = e.target.value.replace(/[^0-9.]/g, '');
                                           let cents = _amount.split('.');
                                           if (cents[1]?.length > 2) {
                                             _amount = parseFloat(_amount).toFixed(2);
                                           }
                                           setTipWarn(null);
                                           if (_amount > parseFloat(cart?.amountDue)) {
                                             _amount = parseFloat(cart?.amountDue);
                                             setTipWarn('Custom tip amount exceeds allowed value')
                                           }
                                           e.target.value = _amount;
                                           setCustomTip(_amount);
                                         }}
                                         InputProps={{
                                           startAdornment: <InputAdornment position="start">
                                             <b>$</b>
                                           </InputAdornment>,
                                         }}/>
                              </span>
                                {tipWarn && <small>{tipWarn}</small>}
                              </>
                              }

                            </div>
                          </Grid>

                        </Grid>
                        }


                        <Grid container justifyContent={'flex-start'}>
                          <Grid item xs={12} sm={12}>
                            <MDBox mt={2}>
                              <>
                                <MDButton
                                  style={{
                                    float: 'right'
                                  }}
                                  disabled={checkoutDisabled()}
                                  variant="gradient"
                                  color="info"
                                  onClick={() => {
                                    continueToCheckoutFinal()
                                  }}>
                                  Continue to Payment
                                </MDButton>
                              </>
                            </MDBox>
                          </Grid>
                        </Grid>
                      </>
                    }
                  </>
                  }

                  {checkoutFinal && cart.amountDue > 0 &&

                    <Grid item xs={12} sm={12}>

                      <MDBox mt={2}>

                        <h6>
                          Payment Method
                        </h6>

                        {!client && <>
                          <MDInput type="text"
                                   autoComplete={'off'}
                                   variant="outlined"
                                   value={guestName || ''}
                                   onChange={(e) => setGuestName(e.target.value)}
                                   className="form-control my-2" id="code" aria-describedby="guestName"
                                   label="Guest Name"/>
                        </>}

                        <Grid container spacing={1}>

                          <Grid item xs={12} sm={6}>
                            <MDButton color={"secondary"} style={{
                              width: '100%',
                              padding: '12px 0'
                            }} size={'small'} variant={displayPaymentMethod === 'new' ? 'contained' : 'outlined'}
                                      onClick={() => {
                                        addPaymentMethodFn(true);
                                        setDisplayPaymentMethod('new');
                                      }}>New Payment Method</MDButton>
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            {cart && cart?.billings?.sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                              .map((item, index) => {
                                return (
                                  // <Grid item xs={12} sm={6} key={index}>
                                  <MDButton color={"secondary"} key={index} style={{
                                    width: '100%',
                                    padding: '12px 0'
                                  }} size={'small'}
                                            variant={displayPaymentMethod === item?.guid ? 'contained' : 'outlined'}
                                            onClick={() => {
                                              setTerminalPayment(false);
                                              updatePaymentMethod(item);
                                              setDisplayPaymentMethod(item?.guid);
                                            }}>{sanitizeCardType(item)} ending in
                                    **** {item.cardNumber} ({item.ccExpy})
                                  </MDButton>

                                )
                              })}
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <MDButton color={"secondary"} style={{
                              width: '100%',
                              padding: '12px 0'
                            }} size={'small'} variant={displayPaymentMethod === 'cash' ? 'contained' : 'outlined'}
                                      onClick={() => {
                                        toggleCashPaymentMethod();
                                        setDisplayPaymentMethod('cash');
                                      }}>Cash Payment</MDButton>
                          </Grid>

                          {client && <Grid item xs={12} sm={6}>
                            <MDButton color={"secondary"} style={{
                              width: '100%',
                              padding: '12px 0'
                            }} size={'small'} variant={displayPaymentMethod === 'tab' ? 'contained' : 'outlined'}
                                      onClick={() => {
                                        toggleTabPaymentMethod();
                                        setDisplayPaymentMethod('tab')
                                      }}>Send to Tab</MDButton>
                          </Grid>}

                          {squareEnabled &&
                            <>

                              <Grid item xs={12} sm={6}>
                                <MDButton color={"secondary"} style={{
                                  width: '100%',
                                  padding: '12px 0'
                                }} size={'small'}
                                          variant={displayPaymentMethod === 'store' ? 'contained' : 'outlined'}
                                          disabled={!client?.guid?.length}
                                          onClick={() => {
                                            setCaptureCard(true);
                                            setDisplayPaymentMethod('store');
                                          }}>Store Card</MDButton>
                              </Grid>
                              {!hasRecurringItems() &&
                                <Grid item xs={12} sm={6}>
                                  <MDButton color={"secondary"} style={{
                                    width: '100%',
                                    padding: '12px 0'
                                  }} size={'small'}
                                            variant={displayPaymentMethod === 'terminal' ? 'contained' : 'outlined'}
                                            onClick={() => {
                                              toggleStoreCardaymentMethod();
                                              setDisplayPaymentMethod('terminal');
                                            }}>Square Terminal Payment</MDButton>

                                </Grid>
                              }

                            </>
                          }

                          {!cart?.invoice && <Grid item xs={12} sm={6}>
                            {client && <MDButton color={"secondary"} style={{
                              width: '100%',
                              padding: '12px 0'
                            }} size={'small'} variant={displayPaymentMethod === 'invoice' ? 'contained' : 'outlined'}
                                                 onClick={() => {
                                                   toggleInvoicePaymentMethod();
                                                   setDisplayPaymentMethod('invoice');
                                                 }}>Invoice Customer</MDButton>
                            }
                          </Grid>
                          }

                        </Grid>


                        <dl className={'row mt-2'}>
                          <dt className={'col col-sm col-12'}>

                            {cart.paymentMethod?.cash && <>
                              <MDInput type="text" step="0.01"
                                       onChange={(e) => {
                                         let _amount = e.target.value;
                                         _amount = e.target.value.replace(/[^0-9.]/g, '');
                                         e.target.value = _amount;
                                         setCashReceived(_amount);
                                       }}
                                       InputProps={{
                                         startAdornment: <InputAdornment position="start">
                                           <span className={'fa fa-dollar'}></span>
                                         </InputAdornment>,
                                       }}
                                       min={0}
                                       placeholder={'Enter Cash Received'}
                                       autoComplete="off"
                                       className="form-control mt-2" id="cashIn"
                                       label="Cash Amount"/>

                              <MDInput type="text" step="0.01"
                                       step={0.01}
                                       disabled={true}
                                       value={changeAmount}
                                       InputProps={{
                                         startAdornment: <InputAdornment position="start">
                                           <span className={'fa fa-dollar'}></span>
                                         </InputAdornment>,
                                       }}
                                       placeholder={"10.00"}
                                       autoComplete="off"
                                       className="form-control mt-2" id="changeDue"
                                       label="Change Due"/>
                            </>
                            }

                            {cart?.paymentMethod?.invoice &&
                              <>
                                <div className={'d-block mb-2'}>
                                  <label>Due Date</label>
                                  <br/>
                                  <DesktopDatePicker
                                    value={invoiceDueDate}
                                    onChange={(e, v) => {
                                      const dueDate = dayjs(e.$d).startOf('day');
                                      const today = dayjs().startOf('day');

                                      setInvoiceDueDate(dueDate);
                                      setInvoiceDueDays(dueDate.diff(today, 'day'))
                                    }}
                                  />
                                </div>
                              </>
                            }

                          </dt>
                        </dl>

                        {cartError && <p style={{
                          textAlign: 'center'
                        }}>We encountered an error processing payment. Please try again.</p>}

                        {addPaymentMethod &&
                          <>
                            {cart?.paymentGatewayId === CONSTANTS.EXT_APPLICATION.SQUARE && <>

                              <SquareCheckoutPage
                                handleSuccess={(e) => {
                                  handleSquareCartSuccess(e)
                                }}
                                handleError={(e) => {
                                  let _cart = {...cart};
                                  _cart.checkoutDisposition = 'CART_API_ERROR';
                                  _cart.error = e.response?.data?.message || e.message;
                                  setCart(_cart);
                                }}
                                cartCheckIn={cartCheckIn}
                                guestName={guestName}
                                client={client}
                                cart={cart}/>
                            </>}
                            {cart?.paymentGatewayId === CONSTANTS.EXT_APPLICATION.STRIPE && <>
                              <StripeCheckoutPage
                                handleSuccess={(e) => {
                                  handleCartSuccess(e)
                                }}
                                handleError={(e) => {
                                  let _cart = {...cart};
                                  _cart.checkoutDisposition = 'CART_API_ERROR';
                                  _cart.error = e.message;
                                  setCart(_cart);
                                }}
                                client={client}
                                cart={cart}/>
                            </>
                            }
                          </>
                        }
                      </MDBox>

                    </Grid>
                  }
                </CartItems>

              </>
              }
              {cart?.checkoutDisposition === 'CART_EMPTY' && <>

                <Col xs={12}>
                  <h5>Your cart is empty.&nbsp;
                    <span
                      className="link cursor-pointer text-info text-decoration-underline"
                      onClick={() => {
                        handleClose(false);
                      }}>
                Continue shopping?</span>
                  </h5>
                </Col>
              </>}

              {cart?.checkoutDisposition === 'CHALLENGE_ACCOUNT' && <>
                {!showLogin && <Grid item xs={12}>
                  <CreateAccount
                    handleCancel={() => {
                      setShowLogin(true);
                    }}
                    handleSave={() => {
                      continueToCheckout();
                    }}
                  />
                </Grid>
                }
              </>
              }

            </Grid>
          </Modal.Body>
          {cart?.checkoutDisposition === 'CHECKOUT_SUCCESS_FINAL' && <>
            <Modal.Footer>
              <MDButton
                variant="gradient"
                color="info"
                onClick={() => {
                  handleClose(true)
                }}>
                Close
              </MDButton>
            </Modal.Footer>
          </>}
          {!addPaymentMethod && <>
            {cart?.checkoutDisposition === 'VIEW_CART' && <>
              <Modal.Footer>
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={() => {
                    continueToCheckout()
                  }}>
                  Continue to Checkout
                </MDButton>
              </Modal.Footer>
            </>
            }
            {
              (checkoutFinal && cart?.checkoutDisposition === 'CHECKOUT_VALID' ||
                cart?.checkoutDisposition === 'QUICK_CHECKOUT' ||
                cart?.checkoutDisposition === 'GIFT_CARD_PURCHASE' ||
                (cart?.checkoutDisposition !== 'CHECKOUT_SUCCESS' &&
                  (cart?.paymentMethod?.tab || cart?.paymentMethod?.terminal || cart?.paymentMethod?.cash || cart?.paymentMethod?.invoice))) && <>
                <Modal.Footer>

                  {terminalPayment && <MDButton variant="gradient"
                                                color="info"
                                                disabled={checkoutDisabled() || checkingOut}
                                                onClick={() => {
                                                  terminalCheckoutFn();
                                                }}>Send to Terminal
                  </MDButton>
                  }
                  {!terminalPayment && <>
                    <MDButton variant="gradient"
                              color="info"
                              disabled={checkoutDisabled() || checkingOut}
                              onClick={() => {
                                checkoutFn();
                              }}>Complete Purchase
                    </MDButton></>}

                </Modal.Footer>
              </>
            }
            {cart?.checkoutDisposition === 'MANAGE_FAMILY_MEMBERS' && <>
              <Modal.Footer>
                {familyMemberRenderIdx &&
                  <>
                    {familyMembers?.length > 0 &&
                      <span style={{
                        float: 'left'
                      }}>
                      <MDButton color="primary"
                                onClick={() => {
                                  getCartFullFn();
                                }}>Back to Cart
                    </MDButton>&nbsp;
                    </span>
                    }
                    <MDButton color="info"
                              disabled={!familyMemberForm?.valid}
                              onClick={saveChildMember}>Save Child
                    </MDButton>

                  </>
                }
              </Modal.Footer>
            </>}

            {cart?.checkoutDisposition === 'LOCKED_MEMBERSHIP_ASSIGN_FAMILY' && <>
              <Modal.Footer>
                {cartRenderIdx && <MDButton variant="gradient"
                                            color="info"
                                            disabled={!validCartMembershipMembers() || cartMembershipSaving}
                                            onClick={() => {
                                              assignAssignCartMembershipMembers(cartMembershipMembers);
                                            }}>{cartMembershipSaving ? 'Updating Cart...' : 'Update Cart'}
                </MDButton>}
              </Modal.Footer>
            </>
            }

            {cart?.checkoutDisposition === 'REQUIRE_ATTENDEES' && <>
              <Modal.Footer>
                {cartRenderIdx && <MDButton variant="gradient"
                                            color="info"
                                            disabled={!cart?.validCartAttendees}
                                            onClick={() => {
                                              updateCartAttendees();
                                            }}>Update Cart
                </MDButton>}
              </Modal.Footer>
            </>
            }

            {(cart?.checkoutDisposition === 'CHECKOUT_SUCCESS'
                || cart?.checkoutDisposition === 'CHECKOUT_SUCCESS_FINAL') && cart?.paymentId &&
              <Modal.Footer>
                {<MDButton variant="gradient" onClick={() => {
                  handleClose('success');
                }}
                           color="info">Close
                </MDButton>}
              </Modal.Footer>
            }
          </>
          }
        </>
        }
      </Modal>
    </>
  )
}